// @ts-nocheck
import * as React from 'react';
import { QUERIES } from '@wix/package-picker-common';
const defaultValue = {};
const BreakpointContext = React.createContext(defaultValue);
const BreakpointProvider = ({ children }) => {
    const [queryMatch, setQueryMatch] = React.useState({});
    React.useEffect(() => {
        const mediaQueryLists = {};
        const keys = Object.keys(QUERIES);
        let isAttached = false;
        const handleQueryListener = () => {
            const updatedMatches = keys.reduce((acc, media) => {
                acc[media] = !!(mediaQueryLists[media] && mediaQueryLists[media].matches);
                return acc;
            }, {});
            setQueryMatch(updatedMatches);
        };
        if (window && window.matchMedia) {
            const matches = {};
            keys.forEach((media) => {
                if (typeof QUERIES[media] === 'string') {
                    mediaQueryLists[media] = window.matchMedia(QUERIES[media]);
                    matches[media] = mediaQueryLists[media].matches;
                }
                else {
                    matches[media] = false;
                }
            });
            setQueryMatch(matches);
            isAttached = true;
            keys.forEach((media) => {
                if (typeof QUERIES[media] === 'string') {
                    mediaQueryLists[media].addListener(handleQueryListener);
                }
            });
        }
        return () => {
            if (isAttached) {
                keys.forEach((media) => {
                    if (typeof QUERIES[media] === 'string') {
                        mediaQueryLists[media].removeListener(handleQueryListener);
                    }
                });
            }
        };
    }, []);
    return (React.createElement(BreakpointContext.Provider, { value: queryMatch }, children));
};
function useBreakpoint() {
    const context = React.useContext(BreakpointContext);
    if (context === defaultValue) {
        throw new Error('useBreakpoint must be used within BreakpointProvider');
    }
    return {
        // @ts-expect-error
        currentBreakpoint: Object.keys(context).find((key) => context[key]),
    };
}
export { BreakpointProvider, useBreakpoint };
//# sourceMappingURL=BreakpointProvider.js.map